<template>
  <svg
    class="custom-icon"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6073_18933)">
      <rect width="40" height="40" rx="20" fill="#0077FF" />
      <g clip-path="url(#clip1_6073_18933)">
        <mask
          id="mask0_6073_18933"
          style="mask-type: luminance"
          maskUnits="userSpaceOnUse"
          x="6"
          y="6"
          width="28"
          height="28"
        >
          <path d="M33.4654 6.40039H6.53467V33.6004H33.4654V6.40039Z" fill="white" />
        </mask>
        <g mask="url(#mask0_6073_18933)">
          <path
            d="M6.53467 19.4564C6.53467 13.3017 6.53467 10.2244 8.42775 8.3124C10.3208 6.40039 13.3677 6.40039 19.4614 6.40039H20.5386C26.6323 6.40039 29.6792 6.40039 31.5723 8.3124C33.4654 10.2244 33.4654 13.3017 33.4654 19.4564V20.5444C33.4654 26.699 33.4654 29.7764 31.5723 31.6884C29.6792 33.6004 26.6323 33.6004 20.5386 33.6004H19.4614C13.3677 33.6004 10.3208 33.6004 8.42775 31.6884C6.53467 29.7764 6.53467 26.699 6.53467 20.5444V19.4564Z"
            fill="#0077FF"
          />
          <path
            d="M20.8641 25.9958C14.7261 25.9958 11.2252 21.7458 11.0793 14.6738H14.1539C14.2549 19.8645 16.5215 22.0631 18.3169 22.5165V14.6738H21.212V19.1505C22.9849 18.9578 24.8474 16.9178 25.4758 14.6738H28.3709C27.8884 17.4392 25.8686 19.4791 24.4323 20.3178C25.8686 20.9978 28.1691 22.7771 29.0443 25.9958H25.8574C25.1729 23.8425 23.4675 22.1765 21.212 21.9498V25.9958H20.8641Z"
            fill="white"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_6073_18933">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_6073_18933">
        <rect width="27.2" height="27.2" fill="white" transform="translate(6.40002 6.40039)" />
      </clipPath>
    </defs>
  </svg>
</template>
